import { render, staticRenderFns } from "./MoodChoice.vue?vue&type=template&id=30ea804e&"
import script from "./MoodChoice.vue?vue&type=script&lang=ts&"
export * from "./MoodChoice.vue?vue&type=script&lang=ts&"
import style0 from "./MoodChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports